<template>
	<div style="padding: 20px;">
		<el-row :gutter="20">
			<el-col :span="12">
				<div class="centext-box">
					<div class="header">
						<span v-if="dealing">
							正在进行支付宝认证
						</span>
						<span v-else>{{is_certify?'':'填写'}}实名信息</span>
					</div>
					<div style="padding: 20px;" class="form">
						<div v-if="!is_certify && !dealing">
							<el-form :model="form_info" :rules="rules" ref="ruleForm" label-width="120px"
								class="demo-ruleForm" label-position="left">
								<el-form-item label="支付宝账号" prop="ali_account">
									<el-input type="text" placeholder="请输入支付宝账号" size="small"
										v-model="form_info.ali_account" style="width: 300px;"></el-input>
								</el-form-item>
								<el-form-item label="真实姓名" prop="real_name">
									<el-input type="text" placeholder="请输入真实姓名" size="small"
										v-model="form_info.real_name" style="width: 300px;"></el-input>
								</el-form-item>
								<el-form-item label="身份证号" prop="id_card">
									<el-input type="text" placeholder="请输入身份证号" size="small" v-model="form_info.id_card"
										style="width: 300px;"></el-input>
								</el-form-item>
								<el-form-item label="手机号" prop="mobile">
									<el-input type="text" placeholder="请输入要绑定的手机号" size="small"
										v-model="form_info.mobile" style="width: 300px;"></el-input>
								</el-form-item>
								<el-form-item>
									<el-button type="primary" size="small"
										@click="submitForm('ruleForm')">立即认证</el-button>
								</el-form-item>
							</el-form>
						</div>
						<div v-if="!is_certify && dealing">
							<el-form ref="ruleForm" label-width="110px" class="demo-ruleForm" label-position="left">
								<el-form-item label="支付宝账号:">
									<span>{{form_info.ali_account}}</span>
								</el-form-item>
								<el-form-item label="真实姓名:">
									<span>{{form_info.real_name}}</span>
								</el-form-item>
								<el-form-item label="身份证号:">
									{{form_info.id_card}}
								</el-form-item>
								<el-form-item label="手机号:">
									{{form_info.mobile}}
								</el-form-item>
								<el-form-item label="当前状态：">
									等待支付宝授权
								</el-form-item>
							</el-form>
						</div>
						<div v-if="is_certify">
							<el-form ref="ruleForm" label-width="75px" class="demo-ruleForm" label-position="left">
								<el-form-item label="真实姓名:">
									<span>{{form_info.real_name}}</span>
								</el-form-item>
								<el-form-item label="身份证号:">
									{{form_info.id_card}}
								</el-form-item>
								<el-form-item label="手机号:">
									{{form_info.mobile}}
								</el-form-item>
								<el-form-item label="认证时间:">
									{{form_info.time}}
								</el-form-item>
							</el-form>
						</div>
					</div>
				</div>
			</el-col>
			<el-col :span="12" v-if="!is_certify">
				<div class="centext-box" style="margin-bottom: 20px;">
					<div class="header">
						认证说明
					</div>
					<div style="padding: 20px;font-size: 14px;color: #ccc;" class="form">
						<div>
							1.如果您需要用到平台的自动售卡功能，则必须完成支付宝实名认证，没有用到自动售卡功能的，可以不用认证。
						</div>
						<div style="margin: 10px 0;">
							2.填写的信息必须和您的个人支付宝信息一致，否则无法通过认证。
						</div>
						<div>
							3.认证通过后，您的自动售卡金额会实时进入您的支付宝账户中。
						</div>
					</div>

				</div>
			</el-col>
			<el-col :span="12">
				<div class="centext-box">
					<div class="header" :style="user.wx_openid?'border-bottom:0px':''">
						{{user.wx_openid?'您已绑定微信号':'您尚未绑定微信号'}}
						<el-button type="danger" v-if="user.wx_openid" size="small"
							style="margin-left: auto;padding: 5px 10px;" @click="free_wechat_bind_click">解 绑</el-button>
					</div>
					<div style="padding:20px 10px;" class="form" v-if="!user.wx_openid">
						<div style="padding: 0px 20px;display: flex;align-items: center;" class="form">
							<el-input size="small" v-model="wechat_verify_code" placeholder="请输入验证码"
								style="width: flex:1;"></el-input>
							<el-button size="small" type="warning" style="margin-left: 10px;padding: 8px 20px;"
								@click="dialogCodeVisible=true">获取验证码</el-button>
						</div>
						<div style="padding:0px 10px;margin-top: 10px;">
							<el-button size="small" type="primary" style="margin-left: 10px;padding: 8px 20px;"
								@click="do_bind_wechat">立即绑定</el-button>
						</div>

					</div>
				</div>
			</el-col>
		</el-row>
		<el-dialog title="请打开支付宝扫一扫进行实名认证" :visible.sync="dialogVisible" width="370px" :before-close="beforeClose">
			<div style="display: flex;align-items: center;justify-content: center;">
				<canvas id="qrcode" width="300" height="300"></canvas>
			</div>
		</el-dialog>
		<el-dialog title="提示" :visible.sync="dialogCodeVisible" width="340px">
			<div style="padding: 10px;display: flex;flex-direction: column;">
				<img src="http://alicdn.2cccc.cc/static//img/qrcode_qlwlkj.jpg" style="width: 100%;height: 100px;">
			</div>
			<div style="padding: 10px 10px 0px 10px;font-size: 14px;">
				关注公众号后点击下方管理中心，获取验证码
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="dialogCodeVisible = false" size="small">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import QRCode from 'qrcode'
	import {
		mapState
	} from 'vuex'
	export default {
		computed: {
			...mapState({
				user: state => state.user
			})
		},
		data() {
			let checkIDCard = (rule, value, callback) => {
				if (!value) {
					return callback(new Error('请输入身份证号'));
				}
				let reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
				if (!reg.test(value)) {
					callback(new Error('身份证号不合法'));
				} else {
					callback();
				}
			};
			let checkMobile = (rule, value, callback) => {
				if (!value) {
					return callback(new Error('请输入手机号'));
				}
				let reg = /^1[3-9]\d{9}$/;
				if (!reg.test(value)) {
					callback(new Error('手机号不合法'));
				} else {
					callback();
				}
			};
			return {
				form_info: {
					ali_account: '',
					real_name: '',
					id_card: '',
					mobile: '',
					time: ''
				},
				rules: {
					ali_account: [{
						required: true,
						message: '请输入支付宝账号',
						trigger: 'blur'
					}],
					real_name: [{
						required: true,
						message: '请输入真实姓名',
						trigger: 'blur'
					}],
					id_card: [{
						required: true,
						validator: checkIDCard,
						trigger: 'blur'
					}],
					mobile: [{
						required: true,
						validator: checkMobile,
						trigger: 'blur'
					}],
				},
				wechat_verify_code: '',
				dialogCodeVisible: false,
				dealing: false,
				data_loaded: false,
				is_certify: false,
				dialogVisible: false
			}
		},
		created() {
			this.getData()
			this.state_check(0)
		},
		filters: {
			formatTime(value) {
				if (value == 0) return ''
				let date = new Date(value * 1000)
				var year = date.getFullYear();
				var month = ("0" + (date.getMonth() + 1)).slice(-2);
				var sdate = ("0" + date.getDate()).slice(-2);
				var hour = ("0" + date.getHours()).slice(-2);
				var minute = ("0" + date.getMinutes()).slice(-2);
				var second = ("0" + date.getSeconds()).slice(-2);
				// 拼接
				var result = year + "-" + month + "-" + sdate + " " + hour + ":" + minute + ":" + second;
				// 返回
				return result;
			}
		},
		methods: {
			beforeClose() {
				this.dealing = false
				this.dialogVisible = false
			},
			do_bind_wechat() {
				this.$H.post('quanlang/v1_0_1.UserBind/BindWechat', {
					verify_code: this.wechat_verify_code
				}).then(res => {
					if (res.data) {
						this.$store.dispatch('setUserInfo')
						this.$message.success('绑定成功')
					}
				});
			},
			free_wechat_bind_click() {
				this.$confirm('您确认解绑微信？', '确认信息', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$H.post('quanlang/v1_0_1.UserBind/FreeWechat').then(result => {
						if (result.data) {
							this.$store.dispatch('setUserInfo')
							this.$message.success('解绑成功')
						}
					});
				}).catch(() => {

				});
			},
			getData() {
				this.$H.post('/quanlang/v1_0_1.User/CertifyInfo', {}).then(res => {
					if (res.data) {
						console.log(res.data.certify_data_hided)
						this.is_certify = res.data.is_certify
						if (res.data.is_certify) {
							this.form_info = {
								ali_account: '',
								real_name: res.data.certify_data_hided.real_name,
								id_card: res.data.certify_data_hided.id_card,
								mobile: res.data.certify_data_hided.mobile,
								time: res.data.certify_data_hided.time
							}
						}

					}
				});
			},
			submitForm() {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						this.$H.post('quanlang/v1_0_1.User/AliCertifyStart', this.form_info).then(res => {
							if (res.data) {
								console.log(res.data)
								this.dealing = true;
								this.state_check(res.data.state);
								this.dialogVisible = true
								setTimeout(() => {
									let canvas = document.getElementById("qrcode")
									let opts = {
										errorCorrectionLevel: 'H',
										type: "image/png",
										quality: 0.3,
										margin: 5,
										width: 350,
										height: 350,
										text: res.data.url,
										color: {
											dark: '#333',
											light: '#fff'
										}

									}
									QRCode.toCanvas(canvas, res.data.url, opts, (err) => {
										console.log(err)
									})
								}, 500)
							}
						});
					}
				})
			},
			state_check(state) {
				this.$H.post('quanlang/v1_0_1.User/AliCretifyContinue', {
					state: state
				}).then(res => {
					if (!res.data) return;
					switch (res.data.status) {
						case 0:
							break;
						case 1:
							this.$message.success('实名认证成功')
							this.getData()
							this.dealing = false;
							break;
						case -1:
							this.dealing = false;
							this.$confirm('实名认证失败：' + res.data.text + '，请重新填写', '提示', {
								confirmButtonText: '确定',
								showCancelButton: false,
								type: 'error'
							}).then(() => {

							}).catch(() => {

							});
					}
					if (this.dealing) setTimeout(() => {
						this.state_check(state);
					}, 1000);
				});
			},
		}
	}
</script>

<style scoped>
	.centext-box {
		border-radius: 5px;
		background-color: rgb(66, 75, 79);
		color: #fff
	}

	.centext-box .header {
		font-size: 14px;

	}

	.form>>>.el-form-item__label {
		color: #fff !important;
	}

	.form>>>.el-input__inner {
		background-color: rgb(66, 75, 79);
		border: 1px solid #ccc !important;
		color: #fff;
	}

	.form>>>.el-radio__label {
		color: #fff;
	}

	.form>>>.el-textarea__inner {
		background-color: rgb(66, 75, 79);
		border: 1px solid #ccc !important;
		color: #fff;
	}

	.t-header {
		padding: 16px;
		border-bottom: 1px solid #909090;
		font-size: 14px;
		font-weight: 700;
		display: flex;
	}

	.t-body {
		padding: 16px;
		border-bottom: 1px solid #909090;
		font-size: 14px;
		font-weight: normal;
		display: flex;
	}

	.t-item {
		flex: 1;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.change-item {
		width: 31%;
		height: 80px;
		align-items: center;
		justify-content: space-between;
		position: relative;
		display: flex;
		flex-direction: column;
		background: #CCCCCC;
		border: 1px solid #EAEAEA;
		opacity: 1;
		margin-bottom: 10px;
		margin-top: 10px;
		border-radius: 5px;
		padding: 20px 0px;
		cursor: pointer;
	}

	.change-item-active {
		background-color: #CBDCFC !important;
		border: 1px solid #4264F0 !important;
	}
</style>